import { render, staticRenderFns } from "./ModalWithCustomActions.vue?vue&type=template&id=3b8ae218"
import script from "./ModalWithCustomActions.vue?vue&type=script&lang=js"
export * from "./ModalWithCustomActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports